<router-outlet></router-outlet>
<div *ngIf="release" class="version">
  <span>{{ release }}</span>
</div>
<rxap-status-indicator class="fixed bottom-0 right-0 z-10"></rxap-status-indicator>
